import React, { useEffect, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { PageWrapper, H1WithBack, Flex, ContentWrapper } from 'styling/GlobalStyles'
import { TaskOperationTab } from './TaskTOperationTab'
import { useDispatch, useSelector } from 'react-redux'
import { addTaskTemplate } from 'features/taskTemplates/taskTemplatesSlice'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { AppDispatch, RootState } from 'store'
import { TaskComponentsTab } from './TaskComponentsTab'
import { ITaskTemplateState } from 'types/task-templates.interface'
import { taskTemplatesInitialState } from './taskData'
import { TaskTDesignTab } from './TaskTDesignTab'
import { TaskTAllowedRolesTab } from './TaskTAllowedRolesTab'
import { TaskTFallBackRolesTab } from './TaskTFallbackRoles'
import { DropDownTabsContainer } from 'components/DropDownTabsContainer/DropDownTabsContainer'
import { TaskTMachinesTab } from './TaskTMachinesTab'

export const AddTaskTemplate = () => {
  const [active, setActive] = useState('Operation')
  const [state, setState] = useState<ITaskTemplateState>(taskTemplatesInitialState)

  const { createdId } = useSelector((store: RootState) => store.taskTemplates)
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()

  const handleSubmit = async () => {
    if (!state.operation?.id) {
      toast.warn('Task operation must be selected.')
      return
    }

    if (!state.requiredCapability?.value) {
      toast.warn('Required capability must be selected.')
      return
    }

    if (!state.requiredMachineCategory?.value) {
      toast.warn('Required category must be selected.')
      return
    }


    if (state.components.some((c) => !c.componentType)) {
      toast.warn('Components must have set component type.')
      return
    }

    if (state.toolTypeComponents.some((t) => !t.name)) {
      toast.warn('Tool type components must have set name.')
      return
    }


    await dispatch(addTaskTemplate(state))
  }

  useEffect(() => {
    if (createdId) {
      navigate('/task-templates/' + createdId + '/edit/logic')
    }
  }, [createdId])

  const renderTabs = () => {
    switch (active) {
      case 'Operation':
        return <TaskOperationTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Allowed Roles':
        return <TaskTAllowedRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Fallback Roles':
        return <TaskTFallBackRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Design':
        return <TaskTDesignTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Components':
        return <TaskComponentsTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Machines':
        return <TaskTMachinesTab state={state} setState={setState} handleSubmit={handleSubmit} />
      default:
        return <TaskOperationTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
  }
  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <H1WithBack arrow title='Add Task' />
          <DropDownTabsContainer
            tabs={['Operation', 'Allowed Roles', 'Fallback Roles', 'Design', 'Components', 'Machines']}
            setActive={setActive}
            active={active}
          />
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </div>
  )
}
